// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__q0D0j","header":"MergedInvoice_header__3Gs2f"};